import React from 'react'
import classes from './Stock.module.sass'
import { Helmet } from 'react-helmet-async'
import { Button } from '../../../common/components/button/Button'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useStock } from './hooks/useStock'
import { StockDocumentType } from '../../../common/types/enums'

export const Stock = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    document,
    setDocument,
    documentType,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    addMovement,
    removeMovement,
  } = useStock()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Документы`}</title>
        <meta name="description" content={`Документы склада`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`документы склада`}</div>
        <Button onClick={() => startCreate(StockDocumentType.RECEIPT)} text="Приход" />
        <Button onClick={() => startCreate(StockDocumentType.WRITE_OFF)} text="Списание" />
      </div>

      <List showDetails={showDetails} startEdit={startEdit} list={list} loading={loading} />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          document={document}
          setDocument={setDocument}
          getList={getList}
          setModalActive={setModalActive}
          documentType={documentType}
          addMovement={addMovement}
          removeMovement={removeMovement}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
